module.exports = __webpack_public_path__ + "img/logo.83ef4570.jpeg";